import { useEffect, useState } from "react";
import { EmptyFloatQuestion, IFloatQuestion } from "./FloatQuestionnaireMast";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { JVCheckbox } from "../../shared/JVCheckbox";

interface IProps {
  singleData: IFloatQuestion;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

const schema = yup.object({
  question: yup.string().required("Question is required"),
  answer_Type: yup.number().required("Answer Type is required").oneOf([1, 2,3], "Please select a valid answer type"),
});

const Form = (props: IProps) => {
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IFloatQuestion>({
    resolver: yupResolver(schema),
    shouldFocusError: false,
    defaultValues: {
      id: 0,
      question: "",
      answer_Type: undefined as any,
      additional_Question: false,
    },
  });

  const onSubmit = async (data: IFloatQuestion) => {
    setLoading(true);

    const isEdit = !!data.id;

    const payload = {
      id: data.id,
      question: data.question,
      answer_Type: data.answer_Type,
      additional_Question: data.additional_Question === undefined || data.additional_Question === null ? false : data.additional_Question,
    };

    const response = await Fetch(isEdit ? "Float/updateQuestions" : "Float/addQuestions", isEdit ? "PUT" : "POST", payload, null, props.toast);

    if (response?.ok) {
      props.toast.current.show({
        severity: "success",
        summary: "Success",
        detail: isEdit ? "Question Updated Successfully" : "Question Added Successfully",
      });
      props.setReload(!props.reload);
      props.hideDialog();
      reset();
    }

    setLoading(false);
  };

  const onHide = () => {
    props.hideDialog();
    reset(EmptyFloatQuestion);
  };

  const answerTypeOption = [
    { name: "Yes/No", value: 1 },
    { name: "Text", value: 2 },
    { name: "Number", value: 3 },
  ];

  useEffect(() => {
    if (props.open) {
      reset(props.singleData);
    }
  }, [props.singleData, props.open]);

  return (
    <>
      <Dialog visible={props.open} onHide={onHide} header="Float Question" style={{ width: "40rem" }}>
        <form onSubmit={handleSubmit(onSubmit, (e) => console.log("errors", e))} className="p-fluid formgrid grid">
          <JVInput required label="Question" control={control} name="question" error={errors.question?.message} />
          <JVDropdown column={3} label="Answer Type" required control={control} name="answer_Type" optionLabel="name" optionValue="value" options={answerTypeOption} placeholder="Select Answer Type" error={errors.answer_Type?.message} />
          <JVCheckbox column={3} control={control} name="additional_Question" label="Additional Question" />
          <div className="col-12 md:col-12 flex gap-4 justify-content-end">
            <Button style={{ width: "100px" }} label="SAVE" type="submit" loading={loading} />
            <Button style={{ width: "100px" }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200" />
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default Form;
